import React from 'react'
import './helper.css'
const GoTop = (props) => {
    return (
        <>
            <div className={props.showGoTop} onClick={props.scrollUp}>
                <button className="goTop">
                    <svg className="goTop__text" xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"/></svg>
                </button>
            </div>
        </>
    );
};
export default GoTop;